import * as React from "react";

import { EnquiryContext } from "./context/EnquiryState";

export const PromoFormHeader = () => {

	const {
		state,
	} = React.useContext(EnquiryContext)

	return (
		<React.Fragment>

			<div className={`relative rounded-xl w-full mb-6 overflow-hidden ${state.currentFormComponent != 'reviewForm' ? 'lg:hidden' : ''}`}>

				<div className="flex flex-row h-auto sm:h-48">
					<img className="object-cover object-bottom w-2/5 max-w-[220px]" src="/img/enquiry/promo-mama-enquiry-banner.png" alt="lady child" />
					<div className="relative flex flex-col justify-center text-center pt-8 pb-6 w-full" style={{ backgroundColor: '#052F49' }}>
						<div className="mb-2 text-xl font-extrabold text-white mx-4 sm:mx-8 leading-tight">
							Complete your enquiry for the chance to
							WIN 12 months FREE childcare,
							up to $10,000
						</div>
						<div>
							<a className="text-white text-xs underline cursor-pointer" href="/pdfs/freechildcare/care-for-kids-12-month-free-childcare-competition.pdf" target="_blank">T&C's apply</a>
						</div>
						<img className="absolute bottom-0 -left-12" src="/img/enquiry/form-header-bottom-arch.png" alt="bottom arch" />
					</div>
				</div>

				<img className="absolute top-0 left-0" src="/img/enquiry/form-header-corner-star.png" alt="corner star" />

			</div>

			{/*OLD PROMO*/}
			{/*<div className={`bg-skin-eggplant relative rounded-xl w-full mb-6 overflow-hidden ${state.currentFormComponent != 'reviewForm' ? 'lg:hidden' : ''}`}>*/}

			{/*	<div className="flex flex-col text-center pt-10 pb-6 mx-8">*/}
			{/*		<div className="mb-2">*/}
			{/*			<span className="text-white font-bold text-2xl leading-none">Complete your enquiry for the chance to</span>*/}
			{/*		</div>*/}
			{/*		<div style={{ transform: 'rotate(1.8deg)' }}>*/}
			{/*			<span className="bg-skin-cacti rounded-xl text-skin-heading font-bold text-2xl px-3 py-1" style={{ letterSpacing: '0.025em' }}>win free childcare</span>*/}
			{/*		</div>*/}
			{/*		<div className="mb-4">*/}
			{/*			<span className="text-white font-bold text-2xl">for 12 months!</span>*/}
			{/*		</div>*/}
			{/*		<div>*/}
			{/*			<span className="text-white text-xs">T&C's apply</span>*/}
			{/*		</div>*/}
			{/*	</div>*/}

			{/*	<img className="absolute top-0 right-0" src="/img/enquiry/mobile-corner-star.png" alt="corner star" />*/}
			{/*	<img className="absolute top-0 left-0" src="/img/enquiry/mobile-corner-sphere.png" alt="corner sphere" />*/}
			{/*	<img className="absolute bottom-0 right-0" src="/img/enquiry/mobile-corner-cloud.png" alt="corner cloud" />*/}

			{/*</div>*/}
		</React.Fragment>
	);
}